// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-privacy-policy-js": require("gatsby-module-loader?name=component---src-pages-privacy-policy-js!/opt/build/repo/src/pages/privacy-policy.js"),
  "component---src-pages-terms-of-service-js": require("gatsby-module-loader?name=component---src-pages-terms-of-service-js!/opt/build/repo/src/pages/terms-of-service.js"),
  "component---src-pages-thanks-js": require("gatsby-module-loader?name=component---src-pages-thanks-js!/opt/build/repo/src/pages/thanks.js"),
  "component---src-pages-why-chouxbox-js": require("gatsby-module-loader?name=component---src-pages-why-chouxbox-js!/opt/build/repo/src/pages/why-chouxbox.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "privacy-policy.json": require("gatsby-module-loader?name=path---privacy-policy!/opt/build/repo/.cache/json/privacy-policy.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "terms-of-service.json": require("gatsby-module-loader?name=path---terms-of-service!/opt/build/repo/.cache/json/terms-of-service.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "thanks.json": require("gatsby-module-loader?name=path---thanks!/opt/build/repo/.cache/json/thanks.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "why-chouxbox.json": require("gatsby-module-loader?name=path---why-chouxbox!/opt/build/repo/.cache/json/why-chouxbox.json"),
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js